const IMAGE_BASE_URL = '/assets/svg/infoIcon';

const POPUP_DATA = {
    SKILL_AND_DIFFICULTY: {
        title: 'Add Difficulty & Skill',
        imageUrl: `${IMAGE_BASE_URL}/skillAndDifficulty.svg`,
        description: 'Select the Difficulty level (Easy, Medium or Difficult) and Skill type (Conceptual, Analytical, Intuitive) of the Question'
    },
    ANSWER: {
        title: 'Answer',
        imageUrl: `${IMAGE_BASE_URL}/answer.svg`,
        description: 'Specify the correct answer(s) to the question'
    }
};

export default POPUP_DATA;